var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 640 480"},domProps:{"innerHTML":_vm._s(_vm.icons[_vm.value])}})
}
var staticRenderFns = []

export { render, staticRenderFns }